import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface InfoAreaProps {
  width?: number;
}

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 343px;
  min-height: 96px;
  border-radius: 16px;
  background-image: ${({ theme }) => theme.joyRide.backgroundImage};
  border-radius: 10px;
  padding: 0.5em;
  text-align: center;
`;

export const InfoArea = styled.article.attrs<any, InfoAreaProps>({})`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;

  & p {
    width: ${({ width }) => width || 174}px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.joyRide.colorText};
  }
`;

export const CloseButton = styled.button`
  background: ${ColorPalette.Transparent};
  color: ${({ theme }) => theme.joyRide.colorText};
  width: 59px;
  height: 24px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
`;
